/* eslint-disable react/prop-types */
/*
Author: Chaitanya
*/

import * as React from 'react';
import {
  createStackNavigator,
  CardStyleInterpolators,
} from '@react-navigation/stack';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { isWeb } from '@global/screens';
import {
  setTitleHeader,
  setDefaultStackOption,
  hasNoAccess,
} from '@global/helpers';

import HamburgerButton from '@components/navbar/HamburgerButton';
import NotificationSettingButton from '@components/navbar/NotificationSettingButton';
import BackButton from '@components/navbar/BackButton';
import ActionButton from '@components/navbar/ActionButton';

import CoaTaxSettingScreen from '@/screens/setting/coa-tax-setting/CoaTaxSettingScreen';
import CoaTaxSettingDetailScreen from '@/screens/setting/coa-tax-setting/CoaTaxSettingDetailScreen';
import CoaTaxSettingFormScreen from '@/screens/setting/coa-tax-setting/CoaTaxSettingFormScreen';

const Stack = createStackNavigator();

// eslint-disable-next-line react/prop-types
const CoaTaxSettingNavigator = ({ navigation }) => {
  const insets = useSafeAreaInsets();

  const goToForm = (props, isAdd = false) => {
    if (
      !isAdd &&
      props &&
      props.route &&
      props.route.params &&
      props.route.params.id
    ) {
      props.navigation.navigate('CoaTaxSettingFormScreen', {
        titleScreen: props.route.params.cost_type,
        name: props.route.params.cost_type,
        id: props.route.params.id,
      });
    } else {
      props.navigation.navigate('CoaTaxSettingFormScreen');
    }
  };

  const hasAccess = !hasNoAccess([
    'superadmin',
    'finance_head',
    'tax_support',
    'general',
  ]);

  return (
    <Stack.Navigator
      initialRouteName="CoaTaxSettingScreen"
      screenOptions={(props) => ({
        headerLeft: () => <HamburgerButton {...props} />,
        headerRight: () => <NotificationSettingButton {...props} />,
        ...setDefaultStackOption(insets, CardStyleInterpolators),
      })}>
      <Stack.Screen
        name="CoaTaxSettingScreen"
        component={CoaTaxSettingScreen}
        options={() => ({
          // headerRight (incl. the mobile Add) is owned by CoaTaxSettingScreen so
          // Add goes through openChild and preserves the list on return.
          title: setTitleHeader('COA Tax Setting'),
        })}
      />
      <Stack.Screen
        name="CoaTaxSettingFormScreen"
        component={CoaTaxSettingFormScreen}
        options={(props) => {
          const route = props.route;
          let title = 'Add COA Tax Setting';
          let isEdit = false;
          let params = {};
          if (route.params && route.params.titleScreen) {
            title = route.params.titleScreen;
            isEdit = true;
            params = route.params;
          }
          return {
            title: setTitleHeader(title),
            headerLeft: () => (
              <BackButton
                {...props}
                isJump={true}
                customBack={{
                  screen: isEdit
                    ? 'CoaTaxSettingDetailScreen'
                    : 'CoaTaxSettingScreen',
                  params: params,
                }}
              />
            ),
            headerRight: isWeb
              ? () => <NotificationSettingButton {...props} />
              : false,
          };
        }}
      />
      <Stack.Screen
        name="CoaTaxSettingDetailScreen"
        component={CoaTaxSettingDetailScreen}
        options={(props) => {
          const route = props.route;
          let title = 'COA Tax Setting Detail';
          if (route.params && route.params.titleScreen) {
            title = route.params.titleScreen;
          }
          return {
            title: setTitleHeader(title),
            headerLeft: () => (
              <BackButton
                {...props}
                isJump={true}
                customBack={{ screen: 'CoaTaxSettingScreen' }}
              />
            ),
            headerRight: () =>
              isWeb ? (
                <NotificationSettingButton {...props} />
              ) : hasAccess ? (
                <ActionButton
                  icon={require('@assets/img/icons/edit-white.svg')}
                  onCallback={() => goToForm(props)}
                />
              ) : (
                false
              ),
          };
        }}
      />
    </Stack.Navigator>
  );
};

export default CoaTaxSettingNavigator;
